export default {
  id: 32,
  title: 'Target #32 - Band-aid',
  url: 'https://cssbattle.dev/play/32',
  colors: ['#FFFFFF', '#F3AC3C', '#A3A368', '#FBE18C'],
  solution:
    '<a a><a b><style>a{position:fixed;top:50;left:175;width:50;height:200}a[a]{background:#f3ac3c;transform:rotate(-45deg)}a[b]{background:#a3a368;transform:rotate(45deg);mix-blend-mode:screen}</style>',
}
